import { IAction, IModule } from './moduleTypes';

export function createReducer<S>(modules: Record<string, IModule>) {
  return (state: S, action: IAction): S => {
    // @ts-ignore
    return Object.keys(modules).reduce(
      (acc: Record<string, unknown>, name: string) => {
        const reducer = modules[name].reducer;
        return {
          ...acc,
          // @ts-ignore
          [name]: reducer(state[name], action),
        };
      },
      {}
    );
  };
}
